import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { AddParkerModalComponent } from '../add-parker-modal/add-parker-modal.component';
import { ParkerService } from '../services/parker.service';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '@shared/services/toast.service';
import { RemovePakerConfirmModalComponent } from '../remove-paker-confirm-modal/remove-paker-confirm-modal.component';
import { MATCH_ERROR_MSG } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-parker-list',
  templateUrl: './parker-list.component.html',
  styleUrls: ['./parker-list.component.scss']
})
export class ParkerListComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  @Input() groupUserId: string = '';
  parkerList:any;
  items: any;
  dummy: string = '../../../../assets/images/dummy-img.png';
  activeItem: any;
  constructor(
    private readonly dialogControlService: DialogControlService,
    private readonly parkerService:ParkerService,
    private readonly confirmationService: ConfirmationService,
    private readonly toastService: ToastService,
  ) { }

ngOnInit(): void {
  this.getGroupUserDriverListByGroupUserId()
  }

  showData(product, event){
    const actionMap = {
      removeParker: () => {
        this.removeParker(product,event);
      }
    }

    this.items = [
      {
        items: [
          {
            label: '',
            icon: '',
          },
          {
            label: 'Remove',
            icon: 'common-icon custom-delete',
            escape: false,
            command: actionMap.removeParker
          },

        ]
      },
    ];
  }

  openAddParkerModal(): void {
    this.dialogControlService.openDialog(AddParkerModalComponent, {
      width: '35%',
      data: {
        groupUserId: this.groupUserId
      }
    });

    this.dialogControlService.onClose().subscribe((response) => {
      if (response.status) {
        this.getGroupUserDriverListByGroupUserId();
      }
    });
  }

  getGroupUserDriverListByGroupUserId(): void {
    
    let request = {
      groupUserId: this.groupUserId,
      search:'',
    }
    this.parkerService.getGroupUserDriverListByGroupUserId(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response) => {
        this.parkerList = response?.data;
        
      } ,
      error: (_error) => { 
        this.parkerList = [];
      }
  });
}

removeParker(event, product): void{
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to remove this Parker?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.parkerService.deleteGroupUserDriverById(product.id,false).pipe(autoUnsubWith(this.destroyRef)).subscribe({
          next: (response) => {
          const successMessage = response?.message;
          this.toastService.showToastMessage('success', 'Success', successMessage);
          this.getGroupUserDriverListByGroupUserId();

}, error: (error) => {
            const errorMessage = error?.error?.message;
            if (errorMessage === MATCH_ERROR_MSG) {
              this.removeParkerConfirmModal(product, errorMessage);
            } else {
              this.toastService.showToastMessage('error', 'Error', errorMessage);
              
              this.getGroupUserDriverListByGroupUserId();
            }

          }
        })
      },
    });
}

  removeParkerConfirmModal(data, message): void {
    this.dialogControlService.openDialog(RemovePakerConfirmModalComponent, {
      width: '25%',
      data: {
        id: data.id,
        message: message,
      }
    });

    this.dialogControlService.onClose().subscribe((response) => {
      if (response.status) {
        this.getGroupUserDriverListByGroupUserId();
      }
    });
  }
  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }

}
